<div class="poam-component" style="height: 100%;">
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
    <div>
      <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif; margin: 10px;">
        Risk Register - Internal Assessment View
      </h2>
    </div>

    <div style="display: flex; flex-direction: row; margin-top: 6px; margin-bottom: 10px; align-items: center;">
      <button mat-raised-button
              style="border-radius: 6px; margin-right: 10px; white-space: nowrap;"
              class="button" [routerLink]="['/risks']">
        Back to Risks
      </button>
      <button mat-raised-button
              style="border-radius: 6px; margin-right: 10px; white-space: nowrap;"
              class="button"
              (click)="exportAllCsv()">
        Download CSV
      </button>
    </div>
  </div>

  <p-table [value]="risks"
           #riskTable
           [rows]="100"
           [reorderableColumns]="true"
           [paginator]="true"
           [pageLinks]="3"
           sortField="dateRaised"
           sortOrder="-1"
           [rowsPerPageOptions]="[10, 20, 50, 100]"
           [resizableColumns]="true"
           [metaKeySelection]="false"
           exportFilename="RiskReport"
           (onColResize)="onColumnResize($event)"
           [columns]="cols">

    <ng-template pTemplate="caption">
      <div class="ui-helper-clearfix flex flex-row justify-content-end">
        <button type="button"
                pButton
                class="risksponge-button"
                icon="pi pi-file-excel"
                iconPos="left"
                (click)="riskTable.exportCSV()">
        </button>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
        <th *ngFor="let col of cols"
            [pSortableColumn]="col.field"
            pResizableColumn
            [ngStyle]="{'width': col.width || 'auto', 'display': col.display === false ? 'none' : 'table-cell'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
      <tr>
        <th *ngFor="let col of cols" [ngSwitch]="col.field" [ngStyle]="{'display': col.display === false ? 'none' : 'table-cell'}">
          <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                 (input)="riskTable.filter($event.target['value'], col.field, 'contains')">
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
      <tr [pSelectableRow]="item">
        <td *ngFor="let col of cols" [ngSwitch]="col.field" style="white-space: normal;" [ngStyle]="{'display': col.display === false ? 'none' : 'table-cell'}">
          <span *ngSwitchDefault>
            <ng-container *ngIf="col.field === 'name'">
              <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 350px;">
                {{ truncateName(item.name, 50) }}
              </div>
            </ng-container>

            <ng-container *ngIf="col.field === 'enterpriseWide' && item.enterpriseWide !== undefined">
              {{ item.enterpriseWide ? 'Yes' : 'No' }}
            </ng-container>

            <ng-container *ngIf="col.field === 'dateRaised'">
              {{ formatDate(item.dateRaised) }}
            </ng-container>

            <ng-container *ngIf="col.field !== 'name' && col.field !== 'enterpriseWide' && col.field !== 'dateRaised'">
              {{ item[col.field] }}
            </ng-container>
          </span>
        </td>
      </tr>
    </ng-template>

  </p-table>
</div>
